var updateCartItemQuantityTimer;
var freeShipping = 3300;

$(function() {

	// 購入制限
	purchaseRestrictions();

	// 数量UP
	$('body').on('mousedown', '.quantity_input div.up', function() {
		clearTimeout(longPressTimer);
		quantityUpdate($(this), Number($(this).parent('.quantity_input').find('.quantity').val()) + 1);
	});

	// 数量UP（長押し）
	$('body').on('press', '.quantity_input div.up', function() {
		longPressQuantity($(this), 1);
	});

	// 数量DOWN
	$('body').on('mousedown', '.quantity_input div.down', function() {
		clearTimeout(longPressTimer);
		quantityUpdate($(this), Number($(this).parent('.quantity_input').find('.quantity').val()) - 1);
	});

	// 数量DOWN（長押し）
	$('body').on('press', '.quantity_input div.down', function() {
		longPressQuantity($(this), -1);
	});

	// 数量変更時の簡単なバリデーション
	$('body').on('change', '.quantity_input .quantity', function() {

		var quantity = $(this).val();

		quantity = quantity.replace(/[０-９]/g, function(string) {
			return String.fromCharCode(string.charCodeAt(0) - 0xFEE0);
		});

		quantity = Number(quantity.replace(/[^0-9]/g, ''));

		quantityUpdate($(this), quantity);
	});

	// 削除（カート）スクリーン表示
	$('body').on('click', '.delete_button', function() {
		deleteCartItemScreenVisible($(this).parents('.cart_row'));
	});

	// 削除（カート）
	$('body').on('click', '.delete_true', function() {
		$('section.common_section').addClass('waiting');
		ajaxShopifyRemoveCartItem($(this).parents('.cart_row'));
	});

	// 削除（カート）スクリーン非表示
	$('body').on('click', '.delete_false', function() {
		deleteCartItemScreenHidden($(this).parents('.cart_row'));
	});

	// お買物を続ける（買い物かごが空の場合） click
	$('body').on('click', '.cart_empty_button', function() {

		// トップページに戻る
		location.href = '../';
	});

	// お買物を続ける click
	$('body').on('click', '.cart_footer_button .common_button_prev', function() {

		// 前のページに戻る
		history.back();
	});

	// ご注文手続きに進む click
	$('body').on('click', '.cart_footer_button .common_button_next', function() {

		if ($('body').attr('invalid-customer') === 'true') {
			location.href = '/pages/invalid-customer';
			return false;
		}

		$('section.common_section').addClass('waiting');

		// フォームを送信
		$('#checkout_form').submit();

		setTimeout(function() {
			$('section.common_section').removeClass('waiting');
		}, 400);
	});
});

function purchaseRestrictions() {

	$.ajax({
		url: '/cart.js',
		type: 'POST',
		contentType: 'application/json',
		dataType: 'json',
	})
	// リクエスト成功
	.done(function(response) {

		// console.log(response);

		let cartQuantity = 0;

		$.when(
			$('section.product_main').attr('check-cart', '0')
		).done(function() {

			$.each(response['items'], function(index, value) {

				if (value.product_id === parseInt($('section.product_main').attr('product-id'))) {
					cartQuantity += value.quantity;
				}
			});
		}).done(function() {

			var cartProduct = [];

			$.when(

				$('.cart_list .quantity_input').each(function() {

					if ($(this).closest('.cart_item').attr('purchase-restrictions') === 'true') {

						if (cartProduct[$(this).closest('.cart_item').attr('product-id')] === undefined) {
							cartProduct[$(this).closest('.cart_item').attr('product-id')] = parseInt($(this).find('input.quantity').val());
						} else {
							cartProduct[$(this).closest('.cart_item').attr('product-id')] += parseInt($(this).find('input.quantity').val());
						}
					}
				})
			).done(function() {

				$('.cart_list .quantity_input').each(function() {

					if (cartProduct[$(this).closest('.cart_item').attr('product-id')] !== undefined) {

						$(this).attr('cart-product', cartProduct[$(this).closest('.cart_item').attr('product-id')].toString());

						if (cartProduct[$(this).closest('.cart_item').attr('product-id')] < 2) {
							$(this).find('div.up').removeClass('inactive');
						} else {
							$(this).find('div.up').addClass('inactive');
						}
					}
				});
			});
		});
	})
	// リクエスト失敗
	.fail(function() {
		console.log('ajax通信エラーが発生しました。');
	});
}

function quantityUpdate(thisButton, quantity) {

	var inventory = Number(thisButton.parent('.quantity_input').find('.quantity').attr('inventory-quantity'));

	if (inventory > 1000) {
		inventory = 1000;
	}

	if (quantity >= 1 && quantity <= inventory) {
		thisButton.parent('.quantity_input').find('.quantity').val(quantity);
		thisButton.parent('.quantity_input').find('.quantity').attr('old-value', quantity);
		productTotalPriceUpdate(thisButton.parent('.quantity_input'));
	} else {
		thisButton.parent('.quantity_input').find('.quantity').val(thisButton.parent('.quantity_input').find('.quantity').attr('old-value'));

		thisButton.parents('.item_quantity').find('.quantity_error').addClass('visible');

		setTimeout(function() {
			thisButton.parents('.item_quantity').find('.quantity_error').removeClass('visible');
		}, 2000);

		return false;
	}

	if (thisButton.parent('.quantity_input').find('.quantity').val() <= 1) {
		thisButton.parents('.quantity_input').find('div.down').addClass('inactive');
	} else {
		thisButton.parents('.quantity_input').find('div.down').removeClass('inactive');
	}

	var	purchaseRestrictions = 0;

	purchaseRestrictions = 2 - parseInt(thisButton.parent('.quantity_input').attr('cart-product'));

	if (thisButton.closest('.cart_item').attr('purchase-restrictions') === 'true' && thisButton.parent('.quantity_input').find('.quantity').val() >= purchaseRestrictions) {
		thisButton.parents('.quantity_input').find('div.up').addClass('inactive');
	} else if (thisButton.parent('.quantity_input').find('.quantity').val() >= inventory) {
		thisButton.parents('.quantity_input').find('div.up').addClass('inactive');
	} else {
		thisButton.parents('.quantity_input').find('div.up').removeClass('inactive');
	}
}

function longPressQuantity(thisButton, amount) {

	var quantity = Number(thisButton.parent('.quantity_input').find('.quantity').val());
	var inventory = Number(thisButton.parent('.quantity_input').find('.quantity').attr('inventory-quantity'));

	if (inventory > 1000) {
		inventory = 1000;
	}

	if (thisButton.hasClass('inactive') === false) {

		quantity += amount;

		quantityUpdate(thisButton, quantity);

		longPressTimer = setTimeout(function() {
			longPressQuantity(thisButton, amount);
		}, 60);
	}
}

function deleteCartItemScreenVisible(cartRow) {

	cartRow.find('.cart_item').after($('section.common_section .delete_screen').clone());

	cartRow.find('.delete_screen').animate(
		{
			opacity: 1,
		},
		200,
		'linear',
		function() {
			$('section.common_section').addClass('waiting');
			cartRow.find('.cart_item').css('opacity', .1);
		}
	);
}

function deleteCartItemScreenHidden(cartRow) {

	cartRow.find('.delete_screen').animate(
		{
			opacity: 0,
		},
		200,
		'linear',
		function() {
			$('section.common_section').removeClass('waiting');
			cartRow.find('.cart_item').css('opacity', 1);
			cartRow.find('.delete_screen').remove();
		}
	);
}

function productTotalPriceUpdate(thisQuantity) {

	clearTimeout(updateCartItemQuantityTimer);

	thisQuantity.find('.information span.text').text('');
	thisQuantity.find('.information').addClass('update');

	updateCartItemQuantityTimer = setTimeout(function() {
		$('section.common_section').addClass('waiting');
		thisQuantity.find('.information').removeClass('update');
		ajaxShopifyUpdateCartItemQuantity(thisQuantity);
	}, 800);
}

function totalPriceUpdate() {

	var totalPrice = 0;

	$('.item_total_price span').each(function() {
		totalPrice = totalPrice + Number($(this).html().replace(/,/g, ''));
	});

	$('#total_price').html(totalPrice.toLocaleString());
}

function ajaxShopifyUpdateCartItemQuantity(thisQuantity) {

	thisQuantity.css('pointer-events', 'none');

	thisQuantity.find('.information span.text').text('カート更新');
	thisQuantity.find('.information').addClass('update');
	thisQuantity.find('.information .spinner').css('opacity', '1');

	var data = {
		id : thisQuantity.parents('li.cart_row').find('.cart_item').attr('line-item-id'),
		quantity : thisQuantity.find('.quantity').val(),
	};

	$.ajax({
		url: '/cart/change.js',
		type: 'POST',
		data: JSON.stringify(data),
		contentType: 'application/json',
		dataType: 'json',
	})
	// リクエスト成功
	.done(function(response) {

		// console.log(response);

		checkCart();

		setTimeout(function() {

			var quantity = Number(thisQuantity.find('.quantity').val());
			var price = Number(thisQuantity.parent('ul').find('.item_price span').html().replace(/,/g, ''));

			var totalPrice = quantity * price;

			thisQuantity.parent('ul').find('.item_total_price span').html(totalPrice.toLocaleString());

			totalPriceUpdate();

			thisQuantity.css('pointer-events', '');

			thisQuantity.find('.information span.text').text('更新完了');
			thisQuantity.find('.information .spinner').css('opacity', '0');

			if ($('.cart_list').find('.information.update').length === 1) {
				$('section.common_section').removeClass('waiting');
			}

			setTimeout(function() {

				thisQuantity.find('.information').removeClass('update');

				if (parseInt(response['total_price']) / 100 < freeShipping) {
					$('.cart_total_price div .delivery_price').addClass('visible');
					$('.cart_total_price div .delivery_price').text('＋送料');
					$('.cart_free_shipping').addClass('visible');
					$('.cart_free_shipping').text('あと' + String(freeShipping - parseInt(response['total_price']) / 100).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') + '円の購入で配送料当社負担');
				} else {
					$('.cart_total_price div .delivery_price').removeClass('visible');
					$('.cart_total_price div .delivery_price').text('');
					$('.cart_free_shipping').removeClass('visible');
					$('.cart_free_shipping').text('');
					$('header .customer_free_shipping').css('display', 'none');
				}
			}, 800);
		}, 1200);
	})
	// リクエスト失敗
	.fail(function() {
		console.log('ajax通信エラーが発生しました。');
	});
}

function ajaxShopifyRemoveCartItem(cartRow) {

	$('section.common_section').addClass('waiting');

	cartRow.find('.delete_button button').css('pointer-events', 'none');

	var data = {
		id : cartRow.find('.cart_item').attr('line-item-id'),
		quantity : 0,
	};

	$.ajax({
		url: '/cart/change.js',
		type: 'POST',
		data: JSON.stringify(data),
		contentType: 'application/json',
		dataType: 'json',
	})
	// リクエスト成功
	.done(function(response) {

		// console.log(response);

		checkCart();

		cartRow.animate(
			{
				opacity: 0,
			},
			200,
			'linear',
			function() {

				cartRow.css('height', cartRow.height() + 'px');
				cartRow.html('');

				$('#total_price').css('opacity', 0);

				cartRow.animate(
					{
						height: 0,
					},
					200,
					'linear',
					function() {

						cartRow.remove();

						totalPriceUpdate();
						$('#total_price').css('opacity', 1);

						$('section.common_section').removeClass('waiting');

						if ($('.cart_row').length === 0) {
							$('section.common_section .cart_empty').addClass('empty');
							$('section.common_section .cart_main').addClass('empty');
						}
					}
				);
			}
		);
	})
	// リクエスト失敗
	.fail(function() {
		console.log('ajax通信エラーが発生しました。');
	});
}
